import React, { memo } from 'react';
import { Typography } from '../Typography';
import { SimpleImage } from '../SimpleImage';
import { LocationMarkerIcon } from '../../icons';
import classNames from 'classnames';
import isEqual from 'lodash.isequal';

export interface StickerCardProps {
  data: {
    isUnlocked: boolean;
    stickerKey: string;
    name: string;
    states: string[];
  };
  renderImage?: (url: string, name: string) => React.ReactNode;
  className?: string;
}

export const StickerCard: React.FC<StickerCardProps> = memo(
  ({ data, renderImage, className }) => {
    return (
      <article
        className={classNames(
          'w-full h-[230px] p-6 drop-shadow-sm hover:shadow-xl  rounded-2xl bg-white flex flex-col items-center transition-all duration-200',
          {
            'grayscale ': !data.isUnlocked,
          },
          className
        )}
      >
        <div className="relative w-full h-[120px] w-full mb-3">
          {renderImage ? (
            renderImage(data.stickerKey, data.name)
          ) : (
            <SimpleImage
              src={data.stickerKey}
              alt={data.name}
              fill
              className="object-contain"
            />
          )}
          <div
            className={classNames(
              'absolute top-0 left-0 w-full h-full bg-white/75',
              { hidden: data.isUnlocked }
            )}
          />
        </div>

        <Typography
          component="h3"
          variant="h6"
          className={classNames('line-clamp-2 text-center !text-[16px] mb-1', {
            'text-neutral-500': !data.isUnlocked,
            'text-neutral-900': data.isUnlocked,
          })}
        >
          {data.name}
        </Typography>

        {data.states.length > 0 ? (
          <div className="flex items-center justify-center gap-1 w-full">
            <LocationMarkerIcon className="w-5 h-5" />
            <Typography
              variant="captionBase"
              className="text-neutral-500 inline"
            >
              {data.states[0]}
            </Typography>
          </div>
        ) : null}
      </article>
    );
  },
  arePropsEqual
);

function arePropsEqual(
  prevProps: StickerCardProps,
  nextProps: StickerCardProps
) {
  return isEqual(prevProps, nextProps);
}
